module.exports = __webpack_public_path__ + "static/media/Lei Zhang Schlitz@2x.126e6c03.jpg";